<template>
  <div class="bg-white text-gray-800 md:px-12 py-10 w-screen">
    <div class="w-[81%] mt-6vw mx-auto">
      <h1 class="text-3xl md:text-4xl font-bold mb-6">{{ privacyTexts.title }}</h1>
      <p class="text-sm text-gray-500 mb-2">{{ privacyTexts.effectiveDate }}</p>
      <p class="text-sm text-gray-500 mb-6">
        {{ privacyTexts.website }}
        <a href="https://creston-group.com/" target="_blank"
          class="text-blue-600 underline">https://creston-group.com/</a>
      </p>

      <section class="space-y-4">
        <p>
          <strong>{{ privacyTexts.legalEntity?.title }}</strong> {{ privacyTexts.legalEntity?.name }}
        </p>
        <p>{{ privacyTexts.commitment }}</p>
        <p>{{ privacyTexts.explanation }}</p>
        <p>{{ privacyTexts.references }}</p>
        <p>{{ privacyTexts.processing }}</p>

        <h2 class="text-2xl font-semibold mt-10">{{ privacyTexts.sections?.scope?.title }}</h2>
        <p>{{ privacyTexts.sections?.scope?.content }}</p>

        <h2 class="text-2xl font-semibold mt-10">{{ privacyTexts.sections?.dataCollection?.title }}</h2>
        <ul class="list-disc pl-5 space-y-2">
          <li>
            <strong>{{ privacyTexts.sections?.dataCollection?.items?.contactDetails?.title }}</strong> {{
              privacyTexts.sections?.dataCollection?.items?.contactDetails?.content }}
          </li>
          <li>
            <strong>{{ privacyTexts.sections?.dataCollection?.items?.businessInfo?.title }}</strong> {{
              privacyTexts.sections?.dataCollection?.items?.businessInfo?.content }}
          </li>
          <li>
            <strong>{{ privacyTexts.sections?.dataCollection?.items?.technicalData?.title }}</strong> {{
              privacyTexts.sections?.dataCollection?.items?.technicalData?.content }}
          </li>
          <li>
            <strong>{{ privacyTexts.sections?.dataCollection?.items?.cookies?.title }}</strong> {{
              privacyTexts.sections?.dataCollection?.items?.cookies?.content }}
          </li>
        </ul>
        <p>{{ privacyTexts.sections?.dataCollection?.sensitiveData }}</p>

        <h2 class="text-2xl font-semibold mt-10">{{ privacyTexts.sections?.dataUsage?.title }}</h2>
        <ul class="list-disc pl-5 space-y-2">
          <li>{{ privacyTexts.sections?.dataUsage?.items?.inquiries }}</li>
          <li>{{ privacyTexts.sections?.dataUsage?.items?.quotations }}</li>
          <li>{{ privacyTexts.sections?.dataUsage?.items?.improvements }}</li>
          <li>{{ privacyTexts.sections?.dataUsage?.items?.compliance }}</li>
          <li>{{ privacyTexts.sections?.dataUsage?.items?.marketing }}</li>
        </ul>

        <h2 class="text-2xl font-semibold mt-10">{{ privacyTexts.sections?.legalBasis?.title }}</h2>
        <p>{{ privacyTexts.sections?.legalBasis?.description }}</p>
        <ul class="list-disc pl-5 space-y-2">
          <li>{{ privacyTexts.sections?.legalBasis?.items?.consent }}</li>
          <li>{{ privacyTexts.sections?.legalBasis?.items?.contractual }}</li>
          <li>{{ privacyTexts.sections?.legalBasis?.items?.legitimate }}</li>
          <li>{{ privacyTexts.sections?.legalBasis?.items?.legal }}</li>
        </ul>
        <p>{{ privacyTexts.sections?.legalBasis?.transfers }}</p>

        <h2 class="text-2xl font-semibold mt-10">{{ privacyTexts.sections?.dataTransfers?.title }}</h2>
        <p>{{ privacyTexts.sections?.dataTransfers?.description }}</p>
        <p>{{ privacyTexts.sections?.dataTransfers?.compliance }}</p>

        <h2 class="text-2xl font-semibold mt-10">{{ privacyTexts.sections?.dataRights?.title }}</h2>
        <p>{{ privacyTexts.sections?.dataRights?.description }}</p>
        <ul class="list-disc pl-5 space-y-2">
          <li>{{ privacyTexts.sections?.dataRights?.items?.access }}</li>
          <li>{{ privacyTexts.sections?.dataRights?.items?.rectify }}</li>
          <li>{{ privacyTexts.sections?.dataRights?.items?.delete }}</li>
          <li>{{ privacyTexts.sections?.dataRights?.items?.object }}</li>
          <li>{{ privacyTexts.sections?.dataRights?.items?.withdraw }}</li>
          <li>{{ privacyTexts.sections?.dataRights?.items?.portability }}</li>
        </ul>
        <p>
          {{ privacyTexts.sections?.dataRights?.contact }}
          <a href="mailto:marketing@creston-group.com" class="text-blue-600 underline">marketing@creston-group.com</a>
        </p>
        <h2 class="text-2xl font-semibold mt-10">{{ privacyTexts.sections?.dataRetention?.title }}</h2>
        <p>{{ privacyTexts.sections?.dataRetention?.content }}</p>

        <h2 class="text-2xl font-semibold mt-10">{{ privacyTexts.sections?.dataSecurity?.title }}</h2>
        <p>{{ privacyTexts.sections?.dataSecurity?.content }}</p>

        <h2 class="text-2xl font-semibold mt-10">{{ privacyTexts.sections?.thirdPartyServices?.title }}</h2>
        <p>{{ privacyTexts.sections?.thirdPartyServices?.content }}</p>

        <h2 class="text-2xl font-semibold mt-10">{{ privacyTexts.sections?.cookiesTracking?.title }}</h2>
        <p>{{ privacyTexts.sections?.cookiesTracking?.content }}</p>

        <h2 class="text-2xl font-semibold mt-10">{{ privacyTexts.sections?.policyUpdates?.title }}</h2>
        <p>{{ privacyTexts.sections?.policyUpdates?.content }}</p>

        <h2 class="text-2xl font-semibold mt-10">{{ privacyTexts.sections?.contact?.title }}</h2>
        <p>{{ privacyTexts.sections?.contact?.description }}</p>
        <ul class="list-none pl-0">
          <li>
            📧 {{ privacyTexts.sections?.contact?.email }}
            <a href="mailto:marketing@creston-group.com" class="text-blue-600 underline">marketing@creston-group.com</a>
          </li>
          <li>
            📍 {{ privacyTexts.sections?.contact?.address }} {{ contactTexts.address }}
          </li>
          <li>📞 {{ privacyTexts.sections?.contact?.phone }} +86-21-3388 2838</li>
        </ul>


      </section>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed } from "vue";
import { useI18n } from 'vue-i18n';
import { pushToDataLayer } from '../utils/gtm';

const { locale, messages } = useI18n();

// 获取隐私政策文本
const privacyTexts = computed(() => {
  return messages.value[locale.value]?.privacyPolicy || {
    title: 'Privacy Policy',
    effectiveDate: 'Effective Date: May 18, 2025',
    website: 'Website:',
    legalEntity: {
      title: 'Legal Entity:',
      name: 'Creston Engineering & Equipment (Shanghai) Co., Ltd.'
    }
  };
});

// 获取联系我们的地址文本
const contactTexts = computed(() => {
  return messages.value[locale.value]?.contactUs || {
    address: 'Address'
  };
});

onMounted(() => {
  pushToDataLayer('page_view', {
    page_location: window.location.href,
    page_title: document.title,
    page_referrer: document.referrer,
  });
});
</script>
